import React from 'react'
import { b64toBlob } from '../../services/utils'

interface DocumentPreviewModalContentProps {
  file: string
  onClose: () => void
}

function DocumentPreviewModalContent({
  file,
  onClose,
}: DocumentPreviewModalContentProps) {
  if (!file) {
    return null
  }

  const pdfFileURL = URL.createObjectURL(b64toBlob(file))

  return (
    <div className="modalDialog dFlex flexColumn mw99">
      <button
        type="button"
        className="btnUnstyled mlAuto fontSizeLg"
        onClick={onClose}
      >
        &times;
      </button>

      <iframe
        src={`/pdfjs/web/viewer.html?file=${pdfFileURL}`}
        className="pdfIframe h77"
        title="PDF"
      />
    </div>
  )
}

export default DocumentPreviewModalContent
